import { createContext, useContext, useEffect, useMemo, useState } from "react";
import translations from "../i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "en");

  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useMemo(() => translations[lang] || translations.en, [lang]);
  const value = useMemo(() => ({ lang, setLang, t, toggle: () => setLang((l) => (l === "en" ? "es" : "en")) }), [lang, t]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useI18n = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useI18n must be inside LanguageProvider");
  return ctx;
};
